import {h, Component} from 'preact';
import {connect} from 'preact-redux';
import HeaderArrow from '/chat/src/components/Header/Arrow'
import HeaderTitle from '/chat/src/components/Header/Title';
import SystemModel from '/chat/src/redux/model/system/model';
import Customization from '/chat/src/redux/model/customization/model';
import {TicketModel} from '/chat/src/redux/model'
import {CloseButton, FaqButton, BackButton} from '/chat/src/components/Buttons';
import HeaderRightToolBelt from '/chat/src/components/Header/Toolbelt/RightSide'
import style from './style.scss'
class Header extends Component {

    constructor() {
        super();

        this._goBack = this._goBack.bind(this);
    }
    render(){
        const { company, conversations, features, name, color, totalUnread } = this.props
        const route = conversations.isEmpty() ? 'StartChatting': 'Conversations'
        const hasFaq = features.get('hasFaq');
        return (
            <div className={style.Header} style={{backgroundColor: color}}>
                <BackButton callback={this._goBack}/>
                {totalUnread !== 0 && <span className={style.UnreadNotis}></span>}
                <HeaderTitle body={name}/>
                <HeaderRightToolBelt>
                    <CloseButton/>
                </HeaderRightToolBelt>
            </div>
        );
    }

    _goBack(){
        this.props.dispatch(SystemModel.goBack());
        this.props.dispatch(TicketModel.setCurrentRoom(''))
    }

}

function mapStateToProps(state) {
    const color = Customization.getColor(state);
    const name = Customization.getCompanyDisplayName(state);
    return {
        totalUnread: TicketModel.getTotalUnread(state),
        company: state.get('company'),
        conversations: state.get('conversations'),
        features: state.get('features'),
        color: color,
        name: name
    };
}

export default connect(mapStateToProps)(Header);



// WEBPACK FOOTER //
// ./routes/Chat/Header/index.js